import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEmploymentDetailsPage = {
  alert: {
    error: 'applicant-employment-details.form.alert.error',
  },
  footer: {
    root: 'applicant-employment-details.footer.root',
  },
  form: {
    employerNameInput: 'applicant-employment-details.form.employer-name-input',
    employerNameInputError:
      'applicant-employment-details.form.employer-name-input-error',
    grossAnnualIncomeInput:
      'applicant-employment-details.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'applicant-employment-details.form.gross-annual-income-input-error',
    h1: 'applicant-employment-details.form.h1',
    h2: 'applicant-employment-details.form.h2',
    jobTitleInput: 'applicant-employment-details.form.job-title-input',
    jobTitleInputError:
      'applicant-employment-details.form.job-title-input-error',
    root: 'applicant-employment-details.form.root',
    submitButton: 'applicant-employment-details.form.submit-button',
  },
  header: {
    drawerButton: 'applicant-employment-details.header.drawer-button',
    previousStepButton:
      'applicant-employment-details.header.previous-step-button',
    root: 'applicant-employment-details.header.root',
  },
  progress: {
    root: 'applicant-employment-details.progress.root',
  },
} as const satisfies PageLocatorMap;
